import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerAnchor, productName, showcaseFeatures } from '../data/content';
import { Button } from './ui/Button';
import { Eyebrow } from './ui/Section';
export function ProductShowcase() {
  return <section className="bg-blush-50 px-4 py-12 md:py-16" data-id="element-220" data-mp="32kjm3ry9wyxo">
      <div className="mx-auto max-w-4xl text-center" data-id="element-221" data-mp="2xlykpp7ac97n">
        <Eyebrow data-id="element-222" data-mp="2xoba2nfdhluq">The complete crochet bag collection</Eyebrow>
        <h2 className="text-2xl font-black uppercase leading-tight text-plum-950 md:text-4xl" data-id="element-223" data-mp="29xfdlczz22h5">{productName}</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-bold leading-relaxed text-berry-700 md:text-base" data-id="element-224" data-mp="24z44x5lexy0i">
          A Practical Collection for Crochet Lovers Who Already Know How to Crochet
        </p>
        <div className="mx-auto mt-4 max-w-2xl space-y-2 text-sm leading-relaxed text-muted md:text-base" data-id="element-225" data-mp="2eufjnnwtn589">
          <p data-id="element-226" data-mp="3v85st92ssjor">You don't need another course explaining basic stitches.</p>
          <p data-id="element-227" data-mp="3qa45ud294080">You're looking for fresh designs, beautiful bag styles, and complete project instructions.</p>
          <p className="font-semibold text-plum-950" data-id="element-228" data-mp="249nrxdmb4a2t">That's what this collection is designed to deliver.</p>
        </div>

        <h3 className="mt-8 text-sm font-black uppercase tracking-wider text-plum-950" data-id="element-229" data-mp="29bd3cudfyprf">Inside your bundle:</h3>
        <ul className="mt-4 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-230" data-mp="2e6ir7yqemei5">
          {showcaseFeatures.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-berry-600/15 bg-white px-4 py-2.5 text-sm font-semibold text-plum-950" data-id="element-231" data-mp="1ljxxirmghqbf">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-berry-600" data-id="element-232" data-mp="1ukmbjmbunqob">
                <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-233" data-mp="1zbmaex4j4itg" />
              </span>
              {item}
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-234" data-mp="12r3soqijrekx">
          <Button href={offerAnchor} size="lg" subtext="Jump to today's launch price + 5 free bonus books" data-id="element-235" data-mp="16u9vtpad4pn6">
            Show me all 105 patterns
          </Button>
        </div>
      </div>
    </section>;
}